import React, { useEffect, useState } from "react";
import {
  Grid,
  AppBar,
  Toolbar,
  Button,
  Alert,
  Snackbar,
  Box,
  Typography,
} from "@mui/material";
import "rsuite/dist/rsuite.min.css";
import { DateRangePicker } from "rsuite";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useParams } from "react-router-dom";
import { format } from "date-fns";
import { FormatNumber, FormatNumberRedeem } from "../../utils/formatNumber";
import Loading from "../Dashboard/Loading";
import TextField from "@mui/material/TextField";
import Datefilter from "../../utils/Datefilter";
import CardsMobileRes from "./CardMobileRes";
import { purchaseVariables, redemptionVariables } from "../../Data/data";

export default function TransactionDatewise(props: any) {
  const SchemeType = {
    ONGPGR: "NIPPON INDIA OVERNIGHT FUND (G)",
    LPIGGR: "NIPPON INDIA LOW DURATION FUND (G)",
    LFIGGR: "NIPPON INDIA LIQUID FUND (G)",
  };
  const [tranx, setTranx] = useState<any>([]);
  const [selectedDate, handleDateChange] = React.useState(null);
  const { folio_id } = useParams();
  const [isError, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [columns, setColumns] = useState([
    {
      field: "id",
      headerName: "S.No",
      width: 90,
      renderHeader: () => <strong>{"S.No"}</strong>,
    },
    {
      field: "SCHEME_NAME",
      headerName: "Fund",
      width: 380,
      renderHeader: () => <strong>{"Fund"}</strong>,
      renderCell: (params) => {
        let { SCHEME_NAME } = params.row;
        // OLD
        // const schemName = SCHEME_NAME.split("/")[1]
        // return <div style={{ minHeight: "50px", alignItems: "center", display: "flex", width: "100%" }}>{schemName}</div>

        // NEW
        return (
          <div
            style={{
              minHeight: "50px",
              alignItems: "center",
              display: "flex",
              width: "100%",
            }}
          >
            {SCHEME_NAME}
          </div>
        );
      },
    },
    {
      field: "TRXN_TYPE",
      headerName: "Transaction Type",
      width: 240,
      renderHeader: () => <strong>{"Transaction Type"}</strong>,
      renderCell: (params) => {
        let { TRXN_TYPE } = params.row;
        const TransactionType = purchaseVariables.test(TRXN_TYPE)
          ? "Purchase"
          : redemptionVariables.test(TRXN_TYPE)
          ? "Redemption"
          : TRXN_TYPE;
        return <div>{TransactionType}</div>;
      },
    },
    {
      field: "UNITS",
      headerName: "Amount",
      width: 180,
      renderHeader: () => <strong>{"Amount / Units"}</strong>,
      renderCell: (params) => {
        const { UNITS, TRXN_STATUS, AMOUNT, TRXN_TYPE, ALL_UNITS } = params.row;
        // const amount =
        //   TRXN_TYPE == "Redemption"
        //     ? ALL_UNITS == "N"
        //       ? UNITS === 'N/A ' ? "Confirmation Pending" :`${FormatNumber(UNITS)} units`
        //       : `All units`
        //     : AMOUNT
        //     ? `Rs ${FormatNumber(AMOUNT)}`
        //     : "Confirmation Pending";
        let amount: any;

        if (TRXN_TYPE === "Redemption") {
          if (ALL_UNITS === "N") {
            const hasUnits = UNITS && UNITS !== "N/A";
            const hasAmount = AMOUNT != null && AMOUNT !== "";

            if (!hasUnits && !hasAmount) {
              amount = "N/A";
            } else if (hasUnits && hasAmount) {
              amount = `Rs ${FormatNumber(AMOUNT)} & ${FormatNumber(
                UNITS
              )} units`;
            } else if (hasAmount) {
              amount = `Rs ${FormatNumber(AMOUNT)}`;
            } else if (hasUnits) {
              amount = `${FormatNumber(UNITS)} units`;
            }
          } else {
            amount = "All units";
          }
        } else {
          amount = AMOUNT
            ? `Rs ${FormatNumber(AMOUNT)}`
            : "Confirmation Pending";
        }
        if (TRXN_STATUS == "Pending") {
          // @ts-ignore
          return (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="body1">{amount}</Typography>
              <Typography
                style={{ color: "#FDD017", textWrap: "wrap" }}
                variant="caption"
              >
                {TRXN_STATUS}
              </Typography>
            </Box>
          );
        } else if (TRXN_STATUS == "Rejected / Reversal") {
          // @ts-ignore
          return (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="body1">{amount}</Typography>
              <Typography
                style={{ color: "red", textWrap: "wrap" }}
                variant="caption"
              >
                {TRXN_STATUS.split("/")[0]}
              </Typography>
            </Box>
          );
        } else {
          // @ts-ignore
          return (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="body1">{amount}</Typography>
              <Typography
                style={{ color: "green", textWrap: "wrap" }}
                variant="caption"
              >
                {TRXN_STATUS}
              </Typography>
            </Box>
          );
        }
      },
    },
    {
      field: "REMARKS",
      headerName: "Order Remarks",
      width: 240,
      renderHeader: () => <strong>{"Order Remarks"}</strong>,
      renderCell: (params) => {
        let { REMARK } = params.row;
        if (REMARK.toLowerCase().includes("declined by the bank")) {
          REMARK = "DECLINED BY BANK";
        }
        return (
          <div
            style={{
              minHeight: "50px",
              display: "flex",
              justifyContent: "center", // Centering the text
              alignItems: "center", // Centering vertically
              width: "100%",
              textAlign: "center", // Optional: Center the text horizontally
            }}
          >
            {REMARK}
          </div>
        );
      },
    },
    {
      field: "PAYMENT_STATUS",
      headerName: "Payment Status",
      width: 240,
      renderHeader: () => <strong>{"Payment Status"}</strong>,
      renderCell: (params) => {
        let { PAYMENT_STATUS } = params.row;
        // if (REMARK.toLowerCase().includes("declined by the bank")) {
        //   REMARK = "DECLINED BY BANK";
        // }
        return <div>{PAYMENT_STATUS}</div>;
      },
    },
    {
      field: "AUTHORIZED_DATE_TIME",
      headerName: "Transaction Date",
      width: 240,
      renderHeader: () => <strong>{"Transaction Date"}</strong>,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 240,
      renderHeader: () => <strong>{"Actions"}</strong>,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const { REMARK, ORDER_ID, TRXN_TYPE } = params.row;

        console.log("REMARKS :::: ", params);

        // const shouldShowButton =
        //   REMARK?.toUpperCase().includes("2FA PENDING") ||
        //   REMARK?.toUpperCase().includes("AUTH PENDING");
        const is2FAPending = REMARK.includes("2FA PENDING");
        const isAuthPending = REMARK.includes("AUTH PENDING");

        const shouldShowGetLink = is2FAPending || isAuthPending;
        const shouldShowCancel = isAuthPending;

        const handleGetLink = async () => {
          console.log("Get Link for:", params.row);
          // Place your logic to get the link here
          let type =
            TRXN_TYPE === "Purchase"
              ? "PUR"
              : TRXN_TYPE === "Redemption"
              ? "RED"
              : null;

          if (!type) {
            throw Error("Transaction Type is Required!");
          }
          try {
            // Replace with your actual API endpoint and payload
            const response = await axios.post(
              `${process.env.REACT_APP_BACKEND_HOST}v1/user/investment/get-short-link`,
              {
                order_id: ORDER_ID, // or any identifier you need to send
                tranx_type: type,
              },
              {
                headers: {
                  Authorization: `Bearer ${props.accessToken}`,
                },
              }
            );

            // let link = null

            const { data } = response?.data;

            console.log("LInk ::::: ", response);

            // if(!firstHolderLink) {
            //     link = response?.data?.data?.firstHolderLink
            // } else {
            //     link = firstHolderLink
            // }
            if (data?.firstHolderLink) {
              window.open(data?.firstHolderLink, "_blank"); // open in new tab
            } else {
              alert("No link returned from server.");
            }
          } catch (error) {
            console.error("Error fetching link:", error);
            alert("Failed to fetch link.");
          }
        };

        const handleCancelTransaction = async () => {
          console.log("Cancel transaction for:", params.row);
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_BACKEND_HOST}v1/user/investment/cancel-transaction`,
              {
                order_no: ORDER_ID,
                client_code: folio_id,
              },
              {
                headers: {
                  Authorization: `Bearer ${props.accessToken}`,
                },
              }
            );

            console.log("Response :::: ", response);

            if (response?.data?.succ) {
              alert("Transaction cancelled successfully.");
              // Optionally, refresh the data grid or perform any additional actions.
            } else {
              alert(response?.data?.message || "Failed to cancel transaction.");
            }
          } catch (error) {
            console.error("Error cancelling transaction:", error);
            alert("Failed to cancel transaction.");
          }
        };

        return (
          <Box
            sx={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            {shouldShowGetLink ? (
              <button
                onClick={handleGetLink}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "#1976d2",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginRight: "5px",
                }}
              >
                Auth & Pay
              </button>
            ) : null}
            {shouldShowCancel ? (
              <button
                onClick={handleCancelTransaction}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "#d32f2f",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            ) : null}
          </Box>
        );
      },
    },
  ]);
  const today = new Date();
  const [loading, setLoading] = useState(false);
  const dateConverter = (str) => {
    const month = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var date = new Date(str);
    var mnth = date.getMonth();
    var day = ("0" + date.getDate()).slice(-2);
    var year = date.getFullYear();
    return `${day}-${month[mnth]}-${year}`;
  };
  const [isDisable, SetisDisable] = useState(true);
  const [IntervalDate, setIntervalDate] = useState({
    startDate: dateConverter(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
    endDate: dateConverter(new Date().getTime()),
  });
  const [Interval, setInterval] = useState({
    startDate: dateConverter(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
    endDate: dateConverter(new Date().getTime()),
  });
  const getTranxData = async () => {
    setLoading(true);
    const startDate = new Date(IntervalDate.startDate).getTime();
    const endDate = new Date(IntervalDate.endDate).getTime();
    const today = new Date().getTime();
    const diff = endDate - startDate;
    const SevenDays = 1000 * 60 * 60 * 24 * 7;

    // Validate if end date is not in future
    if (endDate > today) {
      setLoading(false);
      setMessage("To date cannot be in the future date.");
      setError(true);
      return;
    }
    if (diff > SevenDays) {
      setLoading(false);
      setMessage("Difference between the dates cannot be more than 7 days.");
      setError(true);
      return;
    }

    try {
      const res = axios
        .post(
          `${process.env.REACT_APP_BACKEND_HOST}v1/user/investment/nse/transaction`,
          {
            iin: folio_id,
            from_date: IntervalDate.startDate,
            to_date: IntervalDate.endDate,
            triggered_trxn: "N",
            initiated_by: "B",
          },
          {
            headers: {
              Authorization: `Bearer ${props.accessToken}`,
              device: "web",
            },
          }
        )
        .then((res) => {
          const { data } = res;
          setLoading(false);
          console.log(data);
          if (!data.succ) {
            setError(true);
            if (data.message == "Selected date difference Exceed 60 days") {
              setMessage(
                "Difference between the dates cannot be more than 60 days"
              );
            } else {
              setMessage(data.message);
            }
            setTranx(data.resData);
            return;
          }
          setTranx(data.resData);
        });
    } catch {
      setLoading(false);
      setError(true);
      setTranx([]);
      setMessage("Failed to Fetching Data from Server");
      return;
    }
    SetisDisable(true);
  };
  useEffect(() => {
    getTranxData();
  }, []);

  const changeHandler = (name, value) => {
    setIntervalDate((prev) => ({
      ...prev,
      [name]: dateConverter(value),
    }));
  };
  return (
    <Grid container spacing={2} xs>
      <Grid item xs={12} sx={{ ml: { xs: 0, md: 4 }, height: "100vh" }}>
        <Snackbar
          open={isError}
          autoHideDuration={4000}
          onClose={() => setError(false)}
        >
          <Alert severity="error" style={{ backgroundColor: "red" }}>
            <span style={{ color: "white" }}>{message}</span>
          </Alert>
        </Snackbar>
        <AppBar
          sx={{
            backgroundColor: "white",
            marginLeft: { xs: "5%", md: 0 },
            display: "flex",
            width: { xs: "96vw", md: "81.5vw" },
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
          position="static"
          elevation={0}
        >
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              margin: "0px",
              padding: 0,
            }}
          >
            {/* <TextField
                        label="Scheme"
                        name="scheme"
                        onChange={changeHandler}
                        value={filter.scheme}
                        sx={{ mr: 2 }}
                        select
                        size='small'
                    >
                        {schemes.map((each, idx) => {
                            return (
                                <MenuItem key={idx} value={each.value}>
                                    {each.name}
                                </MenuItem>
                            );
                        })}
                    </TextField> */}

            <Datefilter
              name="startDate"
              label="From Date"
              value={IntervalDate.startDate}
              changeHandler={changeHandler}
              maxDate={Interval.endDate}
              minDate={Interval.startDate}
              inputFormat="dd-MMM-yyyy"
            />
            <Datefilter
              name="endDate"
              label="To Date"
              value={IntervalDate.endDate}
              changeHandler={changeHandler}
              maxDate={Interval.endDate}
              minDate={Interval.startDate}
              inputFormat="dd-MMM-yyyy"
            />

            {/* <DateRangePicker
                            onChange={changeHandler}
                            size='md'
                            appearance='subtle'
                            placement="bottomEnd"
                            editable={true}
                            defaultValue={[new Date(IntervalDate.startDate), new Date(IntervalDate.endDate)]}
                            showOneCalendar={true}
                            character="  to  "
                            format="dd-MM-yyyy"
                            ranges={[]}
                            cleanable={false}
                        /> */}

            <Button
              sx={{ marginTop: "-3px", height: "37px" }}
              variant="contained"
              color="primary"
              onClick={getTranxData}
            >
              Search
            </Button>
          </Toolbar>
        </AppBar>
        {/* <Typography style={{ fontWeight: 600 }} variant="h6">Transactions</Typography> */}
        <Box
          sx={{
            height: "85vh",
            display: { xs: "none", sm: "block" },
            width: { xs: "96.5vw", md: "80vw" },
            ml: { xs: 3, sm: 0 },
          }}
        >
          {loading ? (
            <Loading />
          ) : (
            <DataGrid
              sx={{ mt: 1 }}
              getRowHeight={() => "auto"}
              //  hideFooter={true}
              rowsPerPageOptions={[50, 100, 1000]}
              rows={tranx.map((each: any, idx: number) => {
                return { ...each, id: idx + 1 };
              })}
              columns={columns.map((each, idx) => {
                return {
                  id: idx + 1,
                  ...each,
                  headerAlign: "center",
                  align: "center",
                  sx: {
                    size: 2,
                  },
                };
              })}
            />
          )}
        </Box>
        {loading ? (
          <Loading />
        ) : (
          <Box
            sx={{
              display: { xs: "flex", sm: "none" },
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              marginLeft: "2.5vw",
            }}
          >
            {tranx.map((ele) => {
              return (
                <CardsMobileRes
                  scheme={ele.SCHEME_NAME?.split("/")[1]}
                  Amount={ele.AMOUNT}
                  date={ele.AUTHORIZED_DATE_TIME}
                  TranType={ele.TRXN_TYPE}
                  TranStatus={ele.TRXN_STATUS}
                  setFormData={""}
                  setIsModel={""}
                />
              );
            })}
          </Box>
        )}
      </Grid>
    </Grid>
  );
}
